import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './verificationcode.css';
import { useLocation, useNavigate } from "react-router-dom";

const VerifyCode = () => {
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const initialEmail = location.state?.email || "";

  // Set the initial email when the component mounts
  useState(() => {
    if (initialEmail) {
      setEmail(initialEmail);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("https://backend-n2zq.onrender.com/api/verify", {
        email,
        verificationCode,
      });
      
      toast.success(response.data.message);
      
      // Redirect to sign-in page after a delay
      setTimeout(() => {
        navigate("/sign-in");
      }, 2000); // 2-second delay to show success message

    } catch (error) {
      toast.error(error.response?.data?.message || "Error verifying code");
    }
  };

  return (
    <div className="block">
      <div>
        <form onSubmit={handleSubmit}>
          <h1>Verify Account</h1>
          <div className="input-container">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label>Email</label>
          </div>
          <div className="input-container">
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              required
            />
            <label>Verification Code</label>
          </div>
          <button type="submit">Verify</button>
        </form>
      </div>
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default VerifyCode;







